import React, {useEffect, useState} from "react";
import "./css/global.styles.scss";
import "font-awesome/css/font-awesome.min.css";

import Footer from "./components/commons/footer/footer.component";
import PageRouting from "./pages/page-routing.router.jsx";
import Notifications from "react-notify-toast";
import ImpersonationBanner
    from "./components/commons/navigation/impersonation-banner/impersonation-banner.component.jsx";
import CookieBanner from "./components/commons/cookie-banner/cookie-banner.component";
import cookie from "react-cookies";
import {useSelector} from "react-redux";
import TrinityHeader from "./components/new-header/Components/TrinityHeader/TrinityHeader";
import {getUserIsLoggedin} from "./js/api/auth/_login";
import {authRequest} from "./js/api/auth/_auth-request";
import {TOKEN_REFRESH_TIME} from "./js/api/_config";
import NewHomePage from "./components/new-home-page/components/demos/NewHomePage";
import {Route} from "react-router-dom";

function App() {
    const user = useSelector(({user}) => user.tokens.access_token);

    const [intervalId, setIntervalId] = useState(0)

    let getCookie = cookie.load("trinityCookie");
    const improfileuser = useSelector(({cart}) =>
        cart.impersonateMember ? cart.impersonateMember.userprofile : null
    );

    useEffect(() => {
        if (user) {
            getUserIsLoggedin().then(response => {
                if (response) {
                    let handleToken = setInterval(() => {
                        authRequest().then((response) => {

                        })
                    }, TOKEN_REFRESH_TIME)
                    setIntervalId(handleToken)
                }
            })
        } else {
            clearInterval(intervalId)
        }
    }, [user])

    return (
        <div className="App">
            {improfileuser ? <ImpersonationBanner/> : ""}
            {!getCookie && <CookieBanner/>}
            <TrinityHeader/>
            <main>
                <Route exact path={"/"} render={() => <NewHomePage/>}/>
                <PageRouting/>
            </main>
            <Notifications/>
            <Footer/>
        </div>
    );
}

export default App;
